const config = {
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:3021',
  useJWT: false,
};

export default config;
